<div class="layout-px-spacing bgImg" #layoutScan (mouseover)="mouseOverZone()"
  style="background: url('./../../../../assets/img/delivery/scanProduct.png')">
  <div class="row layout-spacing layout-top-spacing mt-md-0" id="cancel-row">
    <div class="col-12">
      <div class="widget-content searchable-container list">
        <div class="row mt-3">
          <div class="col">
            <h3>Scan Relance</h3>
          </div>

          <div class="col-md-4">
            <div class="alert alertZ font-weight-bold">
              Nombre de colis scanné(s) :
              <span class="">
                {{ requests.length }}
              </span>
            </div>
          </div>
          <div class="col-md-2 mt-1 text-right">
            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
              Secret Code
            </button>
          </div>
        </div>

        <div class="row flex-column-reverse flex-md-row">
          <div id="tableDropdown" class="col-md-12 mb-2">
            <div class="statbox widget box box-shadow maxOne" *ngIf="requests.length">
              <div class="widget-content widget-content-area">
                <div class="table-responsive">
                  <table class="table table-striped mb-4">
                    <thead class="items-header-section table-header">
                      <tr>

                        <th class="text-center">N&deg;</th>
                        <th class="text-center">N° Tentative</th>
                        <th class="text-center">N° Appel</th>
                        <th>Client finale</th>
                        <!-- <th>{{ "CONCIERGERIE.ADDRESS" | translate }}</th> -->

                        <th class="maxW">region de Livraison</th>
                        <th class="text-center">
                          {{ "CONCIERGERIE.STATUS" | translate }}
                        </th>
                        <th class="text-center">Historique</th>
                        <!-- <th class="text-center">Action</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let i = index; let item; of: requests">
                        <td class="text-center">

                          <span class="font-weight-bold">
                            {{ item?.nid }}
                          </span>
                          <div>
                            {{ item?.business?.nomCommercial }}
                          </div>
                        </td>
                        <td class="text-center">{{ item?.nbTentative }}</td>
                        <td class="text-center">{{ item?.nbCall }}</td>

                        <td class="text-center">
                          {{ item?.deliveredToName }} <br />
                          {{ item?.deliveredToPhone }}
                          <br />
                        </td>

                        <td class="text-center font-weight-bold">
                          {{ item?.city }},{{ item?.subDivision }}
                        </td>

                        <td class="text-center">
                          <app-jobs-badge-status [status]="item.status" [item]="item">
                          </app-jobs-badge-status>
                        </td>

                        <td class="text-center">
                          <button class="btn btn-outline-info py-1 mx-auto" style="padding: 1rem 0.5rem"
                            (click)="openJobHistory(item)">
                            <i class="fa fa-clock-o fa-2x"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal history -->
<div class="modal fade" id="history" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "LIVRAISON.TITLE" | translate }}: {{ selectJobInHistoryModal?.nid }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-job-request-history [job]="selectJobInHistoryModal"></app-job-request-history>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Secret Code</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <input [(ngModel)]="secretCode" type="text" class="form-control" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Close
        </button>
        <button type="button" (click)="getWithSpecCode()" class="btn btn-primary">
          Get
        </button>
      </div>
    </div>
  </div>
</div>